import axios from "axios";
import Config from "./../../config/index";
import { updateUserStatus } from "./auth.service";
import RefreshTokenHandler from "./refresh-token";

/**
 *
 * @param email
 * @param amc_name
 * @param type_of_fund
 * @param date_of_incorporation
 * @param fund_name
 * @param symbol_code
 * @param date_of_revocation
 * @param psx_listing
 */
const addFund = async (
  email: string,
  amc_code: string,
  type_of_fund: string,
  dividend_period: string,
  date_of_incorporation: string,
  fund_name: string,
  symbol_code: string,
  date_of_revocation: string,
  psx_listing: string,
  nav: string,
  money_market: string,
  stock_market: string,
  face_value: string,
  term_deposit: string,
  cdc_participant_id: string,
  cdc_account_number: string,
  offer_price: string,
  redemption_price: string,
  outstanding_units: string,
  management_fee_percentage: string,
  sst_on_management_fee_percentage: string,
  amc_reimbursement_exp_percentage: string,
  selling_and_marketing_exp_percentage: string,
  secp_fee_percentage: string,
  secp_supervisory_fee_percentage: string,
  sst_trustee_percentage: number,
  fee_slab: string,
  sale_load_percentage: number,
  backend_load_percentage: number,
  contingent_load_percentage: number,
  sst_sale_backend_contingent_load_percentage: number,
  accounts_operations_percentage: number,
  risk_factor: string,
  nccpl_code?: string,
  fund_type?: string,
  trustee?: string,
  parent_fund?: string,
  loan_installement?: number,
  employee_contribution?: number,
  employer_contribution?: number,
  loan_against_pf?: number,
  revocate?: boolean,
  type_VPS?: string,
  loan_refundable?: boolean,
  company_name?: string,
  ntn?: string,
  company_signatory?: any,
  authorizer_of_pf?: any,
) => {
  const url = `${Config.baseUrl}/fund/`;
  try {
    const body: any = {
      email,
      amc_code,
      type_of_fund,
      dividend_period,
      date_of_incorporation,
      fund_name,
      symbol_code,
      date_of_revocation,
      psx_listing,
      nav,
      money_market,
      stock_market,
      face_value,
      term_deposit,
      cdc_participant_id,
      cdc_account_number,
      offer_price,
      redemption_price,
      outstanding_units,
      management_fee_percentage,
      sst_on_management_fee_percentage,
      amc_reimbursement_exp_percentage,
      selling_and_marketing_exp_percentage,
      secp_fee_percentage,
      secp_supervisory_fee_percentage,
      sst_trustee_percentage,
      fee_slab,
      sale_load_percentage,
      backend_load_percentage,
      contingent_load_percentage,
      sst_sale_backend_contingent_load_percentage,
      accounts_operations_percentage,
      risk_factor,
      nccpl_code,
      fund_type,
      trustee,
      parent_fund,
      loan_installement,
      employee_contribution,
      employer_contribution,
      loan_against_pf,
      revocate,
      type_VPS,
      loan_refundable,
      company_name,
      ntn,
      company_signatory,
      authorizer_of_pf,
    };
    // if (fund_type) {
    //   body.fund_type = fund_type;
    //   body.trustee = trustee;
    //   if (fund_type === "sub_fund") body.parent_fund = parent_fund;
    // }

    let result: any = await axios.post(url, body, {
      headers: {
        Authorization: sessionStorage.getItem("token") || "",
      },
    });
    return result;
  } catch (err: any) {
    if (err.response.data.status == 401) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await addFund(
          email,
          amc_code,
          type_of_fund,
          dividend_period,
          date_of_incorporation,
          fund_name,
          symbol_code,
          date_of_revocation,
          psx_listing,
          nav,
          money_market,
          stock_market,
          face_value,
          term_deposit,
          cdc_participant_id,
          cdc_account_number,
          offer_price,
          redemption_price,
          outstanding_units,
          management_fee_percentage,
          sst_on_management_fee_percentage,
          amc_reimbursement_exp_percentage,
          selling_and_marketing_exp_percentage,
          secp_fee_percentage,
          secp_supervisory_fee_percentage,
          sst_trustee_percentage,
          fee_slab,
          sale_load_percentage,
          backend_load_percentage,
          contingent_load_percentage,
          sst_sale_backend_contingent_load_percentage,
          accounts_operations_percentage,
          risk_factor,
          nccpl_code,
          fund_type,
          trustee,
          parent_fund,
          loan_installement,
          employee_contribution,
          employer_contribution,
          loan_against_pf,
          revocate,
          type_VPS,
          loan_refundable,
          company_name,
          ntn,
          company_signatory,
          authorizer_of_pf,
        );
      } else {
        throw err;
        // return result
      }
    } else {
      throw err;
    }
  }
};

const addDailyNav = async (
  email: string,
  data: any,
  // offer_rate: string,
) => {
  const url = `${Config.baseUrl}/fund/bulk-daily-nav`;
  try {
    let result: any = await axios.post(
      url,
      {
        email,
        data,
      },
      {
        headers: {
          Authorization: sessionStorage.getItem("token") || "",
        },
      },
    );
    return result;
  } catch (err: any) {
    if (err.response.data.status == 401) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await addDailyNav(email, data);
      } else {
        throw err;
        // return result
      }
    } else {
      throw err;
    }
  }
};

const addDailyNavBulkUploader = async (
  email: string,
  data: any,
  // offer_rate: string,
) => {
  const url = `${Config.baseUrl}/fund/bulk-upload-daily-nav`;
  try {
    let result: any = await axios.post(
      url,
      {
        email,
        data,
      },
      {
        headers: {
          Authorization: sessionStorage.getItem("token") || "",
        },
      },
    );
    return result;
  } catch (err: any) {
    if (err.response.data.status == 401) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await addDailyNavBulkUploader(email, data);
      } else {
        throw err;
        // return result
      }
    } else {
      throw err;
    }
  }
};

/***
 * @param email
 */
const getDailyNavByDate = async (
  email: string,
  fund: string,
  nav_date: string,
  amc_code: string,
) => {
  const url = `${Config.baseUrl}/fund/get-daily-nav?email=${email}&fund=${fund}&nav_date=${nav_date}&amc_code=${amc_code}`;
  try {
    let result: any = await axios.get(url, {
      headers: {
        Authorization: sessionStorage.getItem("token") || "",
      },
    });
    return result;
  } catch (err: any) {
    if (err.response.data.status == 401) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await getDailyNavByDate(email, fund, nav_date, amc_code);
      } else {
        throw err;
        // return result
      }
    } else {
      throw err;
    }
  }
};

///

const getDailyNavByFromDateToDate = async (
  email: string,
  amc_code: string,
  fund: string,
  from_date: string,
  to_date: string,
) => {
  const url = `${Config.baseUrl}/fund/get-daily-nav-report?email=${email}&amc_code=${amc_code}&fund=${fund}&from_date=${from_date}&to_date=${to_date}`;
  try {
    let result: any = await axios.get(url, {
      headers: {
        Authorization: sessionStorage.getItem("token") || "",
      },
    });
    return result;
  } catch (err: any) {
    if (err.response.data.status == 401) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await getDailyNavByFromDateToDate(
          email,
          amc_code,
          fund,
          from_date,
          to_date,
        );
      } else {
        throw err;
        // return result
      }
    } else {
      throw err;
    }
  }
};

///

/***
 * @param email
 */
const getDailyNavOfAllFunds = async (
  email: string,
  amc_code: string,
  nav_date: string,
) => {
  const url = `${Config.baseUrl}/fund/get-daily-nav-by-amc-code?email=${email}&amc_code=${amc_code}&nav_date=${nav_date}`;
  try {
    let result: any = await axios.get(url, {
      headers: {
        Authorization: sessionStorage.getItem("token") || "",
      },
    });
    return result;
  } catch (err: any) {
    if (err.response.data.status == 401) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await getDailyNavOfAllFunds(email, amc_code, nav_date);
      } else {
        throw err;
        // return result
      }
    } else {
      throw err;
    }
  }
};

const getDeleteFundNav = async (
  email: string,
  amc_code: string,
  nav_id: string,
) => {
  const url = `${Config.baseUrl}/fund/delete-nav?email=${email}&amc_code=${amc_code}&nav_id=${nav_id}`;
  try {
    let result: any = await axios.delete(url, {
      headers: {
        Authorization: sessionStorage.getItem("token") || "",
      },
    });
    return result;
  } catch (err: any) {
    if (err.response.data.status == 401) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await getDeleteFundNav(email, amc_code, nav_id);
      } else {
        throw err;
        // return result
      }
    } else {
      throw err;
    }
  }
};

/**
 * @param email
 */
const getFunds = async (options?: {
  email?: string;
  page_number?: string;
  page_size?: string;
  fund_code?: string;
  amc_code?: string;
  fund_page?: string;
  parent_fund?: string;
  company_name?: string;
  fund_type?: string;
}) => {
  const {
    fund_type = "",
    email = "",
    page_number = "",
    page_size = "",
    fund_code = "",
    amc_code,
    fund_page,
    parent_fund,
    company_name,
  } = options || {};
  const params: any = {};
  if (fund_page) params.fund_page = fund_page;
  if (parent_fund) params.parent_fund = parent_fund;
  if (company_name) params.company_name = company_name;
  if (fund_type) params.fund_type = fund_type;
  if (email) params.email = email;
  if (page_number) params.page_number = page_number;
  if (page_size) params.page_size = page_size;
  if (fund_code) params.fund_code = fund_code;
  if (amc_code) params.amc_code = amc_code;

  const url = `${Config.baseUrl}/fund`;
  try {
    let result: any = await axios.get(url, {
      params,
      headers: {
        Authorization: sessionStorage.getItem("token") || "",
      },
    });
    return result;
  } catch (err: any) {
    if (err.response.data.status == 401) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await getFunds({
          email,
          page_number,
          page_size,
          fund_code,
          amc_code,
          fund_page,
          parent_fund,
          company_name,
          fund_type,
        });
      } else {
        throw err;
        // return result
      }
    } else {
      throw err;
    }
  }
};
/**
 * @param email
 */
const getFundByAmc = async (
  email: string | null,
  amcCode: string | null,
  fund_code: string = "",
  category?: string,
  company_name?: string,
  fund_type?: string,
) => {
  const url = `${
    Config.baseUrl
  }/fund/by-amc-code?email=${email}&amc_code=${amcCode}&fund_code=${fund_code}${
    category ? `&category=${category}` : ""
  }`;

  const params: any = {};
  if (company_name) params.company_name = company_name;
  if (fund_type) params.fund_type = fund_type;

  try {
    let result: any = await axios.get(url, {
      headers: {
        params,
        Authorization: sessionStorage.getItem("token") || "",
      },
    });
    return result;
  } catch (err: any) {
    if (err.response.data.status == 401) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await getFundByAmc(email, amcCode, fund_code);
      } else {
        throw err;
        // return result
      }
    } else {
      throw err;
    }
  }
};

const getFundsByAmcCodeForUnitholderPortfolio = async (
  email: string | null,
  amcCode: string | null,
  fund_code: string = "",
) => {
  const url = `${Config.baseUrl}/fund/by-amc-code-for-unitholder-portfolio?email=${email}&amc_code=${amcCode}&fund_code=${fund_code}`;
  try {
    let result: any = await axios.get(url, {
      headers: {
        Authorization: sessionStorage.getItem("token") || "",
      },
    });
    return result;
  } catch (err: any) {
    if (err.response.data.status == 401) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await getFundsByAmcCodeForUnitholderPortfolio(
          email,
          amcCode,
          fund_code,
        );
      } else {
        throw err;
        // return result
      }
    } else {
      throw err;
    }
  }
};
const EditFund = async (
  email: string,
  amc_code: string,
  type_of_fund: string,
  dividend_period: string,
  date_of_incorporation: string,
  fund_name: string,
  symbol_code: string,
  date_of_revocation: string,
  psx_listing: string,
  nav: string,
  money_market: string,
  stock_market: string,
  face_value: string,
  term_deposit: string,
  cdc_participant_id: string,
  cdc_account_number: string,
  offer_price: string,
  redemption_price: string,
  outstanding_units: string,
  management_fee_percentage: string,
  sst_on_management_fee_percentage: string,
  amc_reimbursement_exp_percentage: string,
  selling_and_marketing_exp_percentage: string,
  secp_fee_percentage: string,
  secp_supervisory_fee_percentage: string,
  sst_trustee_percentage: number,
  fee_slab: string,
  sale_load_percentage: number,
  backend_load_percentage: number,
  contingent_load_percentage: number,
  sst_sale_backend_contingent_load_percentage: number,
  accounts_operations_percentage: number,
  risk_factor: string,
  nccpl_code?: string,
  fund_type?: string,
  trustee?: string,
  parent_fund?: string,
  loan_installement?: number,
  employee_contribution?: number,
  employer_contribution?: number,
  loan_against_pf?: number,
  revocate?: boolean,
  type_VPS?: string,
  loan_refundable?: boolean,
  company_name?: string,
  ntn?: string,
  company_signatory?: any,
  authorizer_of_pf?: any,
) => {
  const url = `${Config.baseUrl}/fund/update`;
  try {
    let result: any = await axios.post(
      url,
      {
        email,
        amc_code,
        type_of_fund,
        dividend_period,
        date_of_incorporation,
        fund_name,
        symbol_code,
        date_of_revocation,
        psx_listing,
        nav,
        money_market,
        stock_market,
        face_value,
        term_deposit,
        cdc_participant_id,
        cdc_account_number,
        offer_price,
        redemption_price,
        outstanding_units,
        management_fee_percentage,
        sst_on_management_fee_percentage,
        amc_reimbursement_exp_percentage,
        selling_and_marketing_exp_percentage,
        secp_fee_percentage,
        secp_supervisory_fee_percentage,
        sst_trustee_percentage,
        fee_slab,
        sale_load_percentage,
        backend_load_percentage,
        contingent_load_percentage,
        sst_sale_backend_contingent_load_percentage,
        accounts_operations_percentage,
        risk_factor,
        nccpl_code,
        fund_type,
        trustee,
        parent_fund,
        loan_installement,
        employee_contribution,
        employer_contribution,
        loan_against_pf,
        revocate,
        type_VPS,
        loan_refundable,
        company_name,
        ntn,
        company_signatory,
        authorizer_of_pf,
      },
      {
        headers: {
          Authorization: sessionStorage.getItem("token") || "",
        },
      },
    );
    return result;
  } catch (err: any) {
    if (err.response.data.status == 401) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await EditFund(
          email,
          amc_code,
          type_of_fund,
          dividend_period,
          date_of_incorporation,
          fund_name,
          symbol_code,
          date_of_revocation,
          psx_listing,
          nav,
          money_market,
          stock_market,
          face_value,
          term_deposit,
          cdc_participant_id,
          cdc_account_number,
          offer_price,
          redemption_price,
          outstanding_units,
          management_fee_percentage,
          sst_on_management_fee_percentage,
          amc_reimbursement_exp_percentage,
          selling_and_marketing_exp_percentage,
          secp_fee_percentage,
          secp_supervisory_fee_percentage,
          sst_trustee_percentage,
          fee_slab,
          sale_load_percentage,
          backend_load_percentage,
          contingent_load_percentage,
          sst_sale_backend_contingent_load_percentage,
          accounts_operations_percentage,
          risk_factor,
          nccpl_code,
          fund_type,
          trustee,
          parent_fund,
          loan_installement,
          employee_contribution,
          employer_contribution,
          loan_against_pf,
          revocate,
          type_VPS,
          loan_refundable,
          company_name,
          ntn,
          company_signatory,
          authorizer_of_pf,
        );
      } else {
        throw err;
        // return result
      }
    } else {
      throw err;
    }
  }
};
const updateFundStatus = async (
  email: string,
  symbol_code: string,
  status: string,
  amc_code: string,
) => {
  const url = `${Config.baseUrl}/fund/update`;
  try {
    let result: any = await axios.post(
      url,
      { email, symbol_code, status, amc_code },
      {
        headers: {
          Authorization: sessionStorage.getItem("token") || "",
        },
      },
    );
    return result;
  } catch (err: any) {
    if (err.response.data.status == 401) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await updateFundStatus(email, symbol_code, status, amc_code);
      } else {
        throw err;
        // return result
      }
    } else {
      throw err;
    }
  }
};

/**
 *
 *
 * @param search_value
 */
const searchFundAPI = async (
  email: string,
  search_value: string,
  fund_code: string = "",
  amc_code: string = "",
  fund_page: string = "",
  parent_fund: string = "",
) => {
  const url = `${Config.baseUrl}/fund?email=${email}&search_value=${search_value}&fund_code=${fund_code}&amc_code=${amc_code}`;
  const params: any = {};
  if (fund_page) params.fund_page = fund_page;
  if (parent_fund) params.parent_fund = parent_fund;
  try {
    let result: any = await axios.get(url, {
      params,
      headers: {
        Authorization: sessionStorage.getItem("token") || "",
      },
    });
    return result;
  } catch (err: any) {
    if (err.response.data.status == 401) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await searchFundAPI(email, search_value, fund_code, amc_code);
      } else {
        throw err;
        // return result
      }
    } else {
      throw err;
    }
  }
};

/**
 *
 * @param email
 * @param symbol_code
 */
const deleteFund = async (email: string, symbol_code: string) => {
  const url = `${Config.baseUrl}/fund/delete-fund/`;
  try {
    let result: any = await axios.put(
      url,
      { email, symbol_code },
      {
        headers: {
          Authorization: sessionStorage.getItem("token") || "",
        },
      },
    );
    return result;
  } catch (err: any) {
    if (err.response.data.status == 401) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await deleteFund(email, symbol_code);
      } else {
        throw err;
        // return result
      }
    } else {
      throw err;
    }
  }
};

const EditNavFund = async (obj: string) => {
  const url = `${Config.baseUrl}/fund/update`;
  try {
    let result: any = await axios.post(url, obj, {
      headers: {
        Authorization: sessionStorage.getItem("token") || "",
      },
    });
    return result;
  } catch (err: any) {
    if (err.response.data.status == 401) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await EditNavFund(obj);
      } else {
        throw err;
        // return result
      }
    } else {
      throw err;
    }
  }
};

/**
 *
 * @param email
 */
const getFundType = async (email: string) => {
  try {
    const url = `${Config.baseUrl}/mastertxn/mop/?email=${email}`;
    let result: any = await axios.get(url, {
      headers: {
        Authorization: sessionStorage.getItem("token") || "",
      },
    });
    return result;
  } catch (err: any) {
    if (err.response.data.status == 401) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await getFundType(email);
      } else {
        throw err;
        // return result
      }
    } else {
      throw err;
    }
  }
};

/**
 *
 * @param email
 * @param name
 * @param code
 */
const addModeOfPayment = async (email: string, name: string, code: string) => {
  const url = `${Config.baseUrl}/mastertxn/mop/`;
  try {
    let result: any = await axios.post(
      url,
      { email, name, code },
      {
        headers: {
          Authorization: sessionStorage.getItem("token") || "",
        },
      },
    );
    return result;
  } catch (err: any) {
    if (err.response.data.status == 401) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await addModeOfPayment(email, name, code);
      } else {
        throw err;
        // return result
      }
    } else {
      throw err;
    }
  }
};

/**
 *
 * @param email
 * @param name
 * @param code
 */
const addNatureOfTransaction = async (
  email: string,
  name: string,
  code: string,
) => {
  const url = `${Config.baseUrl}/mastertxn/not/`;
  try {
    let result: any = await axios.post(
      url,
      { email, name, code },
      {
        headers: {
          Authorization: sessionStorage.getItem("token") || "",
        },
      },
    );
    return result;
  } catch (err: any) {
    if (err.response.data.status == 401) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await addNatureOfTransaction(email, name, code);
      } else {
        throw err;
        // return result
      }
    } else {
      throw err;
    }
  }
};

/**
 *
 * @param email
 * @param name
 * @param code
 */
const addModeOfTransaction = async (
  email: string,
  name: string,
  code: string,
) => {
  const url = `${Config.baseUrl}/mastertxn/tot/`;
  try {
    let result: any = await axios.post(
      url,
      { email, name, code },
      {
        headers: {
          Authorization: sessionStorage.getItem("token") || "",
        },
      },
    );
    return result;
  } catch (err: any) {
    if (err.response.data.status == 401) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await addModeOfTransaction(email, name, code);
      } else {
        throw err;
        // return result
      }
    } else {
      throw err;
    }
  }
};

/**
 *
 * @param email
 * @param name
 * @param code
 */
const addInstrumentType = async (email: string, name: string, code: string) => {
  const url = `${Config.baseUrl}/mastertxn/it/`;
  try {
    let result: any = await axios.post(
      url,
      { email, name, code },
      {
        headers: {
          Authorization: sessionStorage.getItem("token") || "",
        },
      },
    );
    return result;
  } catch (err: any) {
    if (err.response.data.status == 401) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await addInstrumentType(email, name, code);
      } else {
        throw err;
        // return result
      }
    } else {
      throw err;
    }
  }
};
/**
 *
 * @param email
 */
const getInstrumentType = async (email: string) => {
  const url = `${Config.baseUrl}/mastertxn/it?email=${email}`;
  try {
    let result: any = await axios.get(url, {
      headers: {
        Authorization: sessionStorage.getItem("token") || "",
      },
    });
    return result;
  } catch (err: any) {
    if (err.response.data.status == 401) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await getInstrumentType(email);
      } else {
        throw err;
        // return result
      }
    } else {
      throw err;
    }
  }
};

const UpdateNavOfAllFunds = async (email: string, funds: string) => {
  const url = `${Config.baseUrl}/fund/update-multiple`;
  try {
    let result: any = await axios.post(
      url,
      { email, funds },
      {
        headers: {
          Authorization: sessionStorage.getItem("token") || "",
        },
      },
    );
    return result;
  } catch (err: any) {
    if (err.response.data.status == 401) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await UpdateNavOfAllFunds(email, funds);
      } else {
        throw err;
        // return result
      }
    } else {
      throw err;
    }
  }
};

const bulkAddFundExpense = async (
  email: string,
  amc_code: string,
  fund_code: string,
  expenses: any[],
) => {
  const url = `${Config.baseUrl}/fundexpense/multiple`;
  try {
    let result: any = await axios.post(
      url,
      {
        email,
        amc_code,
        fund_code,
        expenses,
      },
      {
        headers: {
          Authorization: sessionStorage.getItem("token") || "",
        },
      },
    );
    return result;
  } catch (err: any) {
    if (err.response.data.status == 401) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await bulkAddFundExpense(email, amc_code, fund_code, expenses);
      } else {
        throw err;
        // return result
      }
    } else {
      throw err;
    }
  }
};

const getFundExpenses = async (
  email: string,
  amc_code: string,
  fund_code: string,
) => {
  const url = `${Config.baseUrl}/fundexpense/?email=${email}&amc_code=${amc_code}&fund_code=${fund_code}`;
  try {
    let result: any = await axios.get(url, {
      headers: {
        Authorization: sessionStorage.getItem("token") || "",
      },
    });
    return result;
  } catch (err: any) {
    if (err.response.data.status == 401) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await getFundExpenses(email, amc_code, fund_code);
      } else {
        throw err;
        // return result
      }
    } else {
      throw err;
    }
  }
};

const validateFundNav = async (
  email: string,
  amc_code: string,
  fund_code: string,
  date: string,
) => {
  const url = `${Config.baseUrl}/fund/nav-existence?email=${email}&amc_code=${amc_code}&fund_code=${fund_code}&date=${date}`;
  try {
    let result: any = await axios.get(url, {
      headers: {
        Authorization: sessionStorage.getItem("token") || "",
      },
    });
    return result;
  } catch (err: any) {
    if (err.response.data.status == 401) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await validateFundNav(email, amc_code, fund_code, date);
      } else {
        throw err;
        // return result
      }
    } else {
      throw err;
    }
  }
};

const fundInvestmentSmry = async (email: string, amc_code: string) => {
  const url = `${Config.baseUrl}/fund/fund-Investment-summary?email=${email}&amc_code=${amc_code}`;
  // const url = `${Config.baseUrl}/amc?email=${email}&page_number=${page_number}&page_size=${page_size}&filter_email=${filter_email}`;
  try {
    const result: any = await axios.get(url, {
      headers: {
        Authorization: sessionStorage.getItem("token") || "",
      },
    });
    return result;
  } catch (err: any) {
    if (
      err.response.data.status == 401 ||
      err.response.status == 403 ||
      err.response.statusCode == 403
    ) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await fundInvestmentSmry(email, amc_code);
      } else {
        throw err;
        // return result
      }
    } else {
      throw err;
    }
  }
};

export {
  addFund,
  UpdateNavOfAllFunds,
  EditNavFund,
  EditFund,
  updateFundStatus,
  getFundByAmc,
  getFunds,
  getInstrumentType,
  deleteFund,
  searchFundAPI,
  getFundType,
  addModeOfPayment,
  addNatureOfTransaction,
  addModeOfTransaction,
  addInstrumentType,
  addDailyNav,
  getDailyNavByDate,
  getDailyNavOfAllFunds,
  getDailyNavByFromDateToDate,
  bulkAddFundExpense,
  getFundExpenses,
  validateFundNav,
  fundInvestmentSmry,
  getFundsByAmcCodeForUnitholderPortfolio,
  addDailyNavBulkUploader,
  getDeleteFundNav,
};
